import { Injectable } from "@angular/core";

@Injectable()
export class PaymentMode {
    public static NET_BANKING = "NB";
    public static NEFT_RTGS = "MANUAL";
    public static TPV = "TPV";
    public static UPI = "UPI";    
    public static undefined = "null";
}